export const USER_GROUP_ID = {
  DEV: {
    ADMIN: '0cfbea5c-9982-43fd-9d9c-64d11c9b9dd7',
    USER: 'b1bc3c41-b5e0-49ea-b36b-4cb99daf020e',
  },
  SIT: {
    ADMIN: '0cfbea5c-9982-43fd-9d9c-64d11c9b9dd7',
    USER: 'b1bc3c41-b5e0-49ea-b36b-4cb99daf020e',
  },
  UAT: {
    ADMIN: '49bed1f5-b38f-4454-8203-d6155e38c613',
    USER: 'd61f75f8-7727-4708-a212-347cb7af3407',
  },
  PROD: {
    ADMIN: 'ae4ee6d2-ebbe-4777-8453-4dce634b959c',
    USER: '36d18649-be8d-4fd8-bcda-b10bac105a72',
  },
};
